import React from 'react';
import { useFetchCityyearStatsQuery } from '../../../slices/authApi';
import classes from './CityYearStats.module.css';
import { Tooltip } from '@mui/material';

const CityYearStats = () => {
  const { data: statsData = {}, isLoading, error } = useFetchCityyearStatsQuery();

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error loading stats.</p>;

  const { streak, leaderboard } = statsData;

  return (
    <div className={classes.container}>
      <div className={classes.topContainer}>
        <div className={classes.leftDiv}>
          City Year Leaderboard
        </div>
        <Tooltip arrow
          title={
            <span style={{ fontSize: '1rem' }}>
              Your streak represents how many days you've been active since the last "break". It's only broken
              by being inactive for a whole school week, and school holidays don't count. Keep it up!
            </span>
          }
        >
          <div className={classes.rightDiv}>
            Your Streak: {streak}
          </div>
        </Tooltip>
      </div>

      <div className={classes.content}>
        <ul className={classes.list}>
          {Object.entries(leaderboard || {})
            .sort(([, scoreA], [, scoreB]) => scoreB - scoreA) // Sort by score descending
            .slice(0, 5) // Take the top 5 entries
            .map(([username, score], index) => (
              <li key={username} className={classes.listItem}>
                {index + 1}&nbsp;&nbsp;&nbsp; <strong>{username}</strong>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
};

export default CityYearStats;
